import { http } from 'utils'

import { Report13CreateFormTypes, Report13APISchemas} from "schemas/reports-#-13-schemas"

export const  postReport13Service = async(payload: Report13CreateFormTypes) => {

    const url = `/merchant/individual-transaction-reports`
    const response = await http.post(url, payload)
    const result = Report13APISchemas.safeParse(response.data)
    if (!result.success) 
      throw result.error
    return result.data
}
